import { combineReducers } from "redux";
// slices
import authSlice from "./features/auth-slice";
import categorySlice from "./features/category-slice";
import courseSlice from "./features/course-slice";
import dashboardSlice from "./features/dashboard-slice";
import enrollmentSlice from "./features/enroll-slice";
import levelSlice from "./features/level-slice";
import mediaSlice from "./features/media-slice";
import successStorySlice from "./features/success-stories-slice";
import testimonialSlice from "./features/testimonial-slice";

// ----------------------------------------------------------------------

// Combine reducers
const rootReducer = combineReducers({
  auth: authSlice,
  category: categorySlice,
  level: levelSlice,
  enrollment: enrollmentSlice,
  course: courseSlice,
  media: mediaSlice,
  testimonial: testimonialSlice,
  successStory: successStorySlice,
  dashboard: dashboardSlice,
});

// Infer the `RootState` type from the rootReducer
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
